// extracted by mini-css-extract-plugin
export var createdDate = "_fo-1";
export var divider = "_fo-2";
export var headerDivider = "_fo-3";
export var messagesCard = "_fo-0";
export var messagesContainer = "_fo-7";
export var messagesContainerWrapper = "_fo-4";
export var pointerCapturingButtonBoxes = "_fo-a";
export var showLeftPanelButton = "_fo-9";
export var showMoreButton = "_fo-c";
export var showMoreButtonContainer = "_fo-b";
export var summaryTitle = "_fo-6";
export var systemMessageCardWrapper = "_fo-d";
export var topButtons = "_fo-8";
export var withPadding = "_fo-5";